import { useState } from "react";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { MENU, money } from "../data";
import { ProductModal } from "./ProductModal";
import { useCart } from "../context/CartContext";
import { toast } from "sonner";

export const Menu = () => {
  const { addItem } = useCart();
  const [modalProduct, setModalProduct] = useState(null);

  const handleClick = (item) => {
    if (item.type === "simple") {
      addItem({
        id: item.id,
        name: item.name,
        basePrice: item.price,
        type: "simple",
        qty: 1,
        salsa: null,
        crema: null,
        queso: null,
        notes: "",
        extras: [],
        unitPrice: item.price,
      });
      toast.success(`${item.name} agregado al pedido`);
    } else {
      setModalProduct(item);
    }
  };

  return (
    <section
      id="menu"
      data-testid="menu-section"
      className="relative py-20 md:py-28 bg-brand-cream"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <p className="text-brand-gold uppercase tracking-[0.3em] text-xs mb-4">
            Nuestro menú
          </p>
          <h2 className="font-display text-3xl lg:text-5xl font-bold text-brand-burgundy leading-tight">
            Arma tu pedido
          </h2>
          <p className="mt-4 text-brand-burgundy/70">
            Elige tus platillos, personalízalos y envía tu pedido directo por
            WhatsApp. Precios en pesos mexicanos.
          </p>
        </div>

        <div className="space-y-14">
          {MENU.map((group, gi) => (
            <div key={group.category} data-testid={`menu-category-${gi}`}>
              <div className="flex items-baseline gap-4 mb-6">
                <h3 className="font-display text-2xl md:text-3xl font-bold text-brand-burgundy whitespace-nowrap">
                  {group.category}
                </h3>
                <span className="h-px flex-1 bg-brand-gold/40" />
                <span className="text-xs uppercase tracking-[0.15em] text-brand-gold font-semibold whitespace-nowrap hidden sm:block">
                  {group.note}
                </span>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {group.items.map((item, ii) => (
                  <motion.div
                    key={item.id}
                    data-testid={`menu-item-${item.id}`}
                    initial={{ opacity: 0, y: 14 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-40px" }}
                    transition={{ duration: 0.4, delay: (ii % 2) * 0.05 }}
                    className="group flex items-center gap-4 bg-white border border-brand-gold/25 rounded-xl px-5 py-4 hover:border-brand-gold hover:shadow-lg hover:shadow-brand-burgundy/5 transition-all"
                  >
                    <div className="flex-1 min-w-0">
                      <h4 className="font-sans text-lg sm:text-xl font-bold text-brand-burgundy leading-tight">
                        {item.name}
                      </h4>
                      <p className="text-brand-gold font-extrabold text-lg mt-0.5">
                        {money(item.price)}
                      </p>
                      {["individual", "chilaquiles", "granel", "sabor"].includes(
                        item.type,
                      ) && (
                        <span className="inline-block mt-1.5 text-[15px] leading-none font-bold uppercase tracking-wide text-brand-red bg-brand-gold/20 border border-brand-gold/40 px-2.5 py-1 rounded-md">
                          Personalizable
                        </span>
                      )}
                    </div>
                    <button
                      onClick={() => handleClick(item)}
                      data-testid={`add-btn-${item.id}`}
                      aria-label={`Agregar ${item.name}`}
                      className="shrink-0 flex items-center gap-1.5 bg-brand-burgundy text-brand-cream font-bold text-sm pl-3 pr-4 py-2.5 rounded-full hover:bg-brand-red transition-colors active:scale-95"
                    >
                      <Plus className="w-4 h-4" />
                      Agregar
                    </button>
                  </motion.div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {modalProduct && (
        <ProductModal
          product={modalProduct}
          onClose={() => setModalProduct(null)}
        />
      )}
    </section>
  );
};
